// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3MZHx","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3PyNk"};